module.exports = __webpack_public_path__ + "img/courseDetailAvatar.8b0e8221.png";